import React from 'react';
import { MessageSquare, Send, History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Separator } from '@/components/ui/separator';
import { formatDate } from './helpers';

export const MessagesCard = ({ report, newMessage, setNewMessage, sendingMessage, onSendMessage }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <MessageSquare className="w-5 h-5" />
        Mensagens
      </CardTitle>
      <CardDescription>Comunicação com o denunciante</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4 max-h-80 overflow-y-auto mb-4">
        {report.messages && report.messages.length > 0 ? (
          report.messages.map((msg, idx) => (
            <div
              key={msg.id || msg.created_at || `msg-${idx}`}
              className={`p-3 rounded-lg ${
                msg.sender_type === 'manager'
                  ? 'bg-sky-50 ml-8'
                  : 'bg-slate-100 mr-8'
              }`}
            >
              <div className="flex justify-between items-start mb-1">
                <span className="text-xs font-medium text-slate-500">
                  {msg.sender_type === 'manager' ? (
                    <>
                      {msg.sender_name || 'Gestor'}
                      {msg.sender_role && (
                        <span className="ml-1 text-slate-400">({msg.sender_role})</span>
                      )}
                    </>
                  ) : 'Denunciante'}
                </span>
                <span className="text-xs text-slate-400">{formatDate(msg.created_at)}</span>
              </div>
              <p className="text-sm text-slate-700">{msg.content}</p>
              {msg.sender_type === 'manager' && (
                <div className="mt-1 text-[10px] text-slate-400 flex items-center gap-1">
                  <History className="w-3 h-3" />
                  Enviado por {msg.sender_name || 'Sistema'}
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-center text-slate-400 py-4">Sem mensagens</p>
        )}
      </div>

      <Separator className="my-4" />

      <div className="flex gap-2">
        <Textarea
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Escrever mensagem ao denunciante..."
          rows={2}
          className="flex-1"
          data-testid="admin-message-textarea"
        />
        <Button onClick={onSendMessage} disabled={sendingMessage || !newMessage.trim()} data-testid="admin-send-message-btn">
          <Send className="w-4 h-4" />
        </Button>
      </div>
    </CardContent>
  </Card>
);
